<app-uri-handler></app-uri-handler>
<router-outlet></router-outlet>